import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, Lock, Zap } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 bg-stone-50" data-id="element-201">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto bg-white rounded-[2rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-stone-100 p-6 md:p-10 lg:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-203">
          {/* Left: Premium Trust Badge */}
          <div className="relative flex-shrink-0 group" data-id="element-204">
            {/* Soft glow behind the badge */}
            <div className="absolute inset-0 bg-emerald-400/20 blur-3xl rounded-full group-hover:bg-emerald-400/30 transition-colors duration-500" data-id="element-205"></div>

            {/* Badge Container */}
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-full bg-gradient-to-b from-white to-emerald-50/80 shadow-2xl shadow-emerald-900/5 border-8 border-white flex flex-col items-center justify-center relative z-10 overflow-hidden" data-id="element-206">
              {/* Subtle inner ring */}
              <div className="absolute inset-2 border border-emerald-100/50 rounded-full" data-id="element-207"></div>

              <ShieldCheck className="w-14 h-14 md:w-16 md:h-16 text-emerald-500 mb-3" strokeWidth={1.5} data-id="element-208" />

              <div className="text-center px-4" data-id="element-209">
                <span className="block text-stone-900 font-black text-2xl md:text-3xl leading-none tracking-tight mb-1.5" data-id="element-210">
                  7 DÍAS
                </span>
                <span className="block text-emerald-600 font-bold text-[10px] md:text-xs uppercase tracking-[0.2em] leading-tight" data-id="element-211">
                  Garantía de
                  <br data-id="element-212" />
                  Satisfacción
                </span>
              </div>
            </div>
          </div>

          {/* Right: Text Content */}
          <div className="text-center md:text-left flex-1" data-id="element-213">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-bold uppercase tracking-widest mb-5 border border-emerald-100" data-id="element-214">
              <ShieldCheck className="w-3.5 h-3.5" data-id="element-215" />
              Cero Riesgo
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-stone-900 mb-5 tracking-tight leading-tight" data-id="element-216">
              Pruébalo durante 7 días sin riesgo
            </h2>

            <p className="text-lg md:text-xl text-stone-500 leading-relaxed mb-10 max-w-2xl mx-auto md:mx-0" data-id="element-217">
              Si no ves cambios en tus rutinas familiares, te devolvemos el 100%
              de tu dinero.{' '}
              <span className="text-stone-900 font-semibold" data-id="element-218">
                Sin preguntas.
              </span>
            </p>

            {/* Trust Line */}
            <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center md:justify-start gap-y-4 gap-x-8 pt-6 border-t border-stone-100" data-id="element-219">
              <div className="flex items-center gap-2 text-sm font-semibold text-stone-600" data-id="element-220">
                <Lock className="w-4 h-4 text-emerald-500" data-id="element-221" />
                <span data-id="element-222">Compra segura</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-stone-600" data-id="element-223">
                <Zap className="w-4 h-4 text-emerald-500" data-id="element-224" />
                <span data-id="element-225">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-stone-600" data-id="element-226">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" data-id="element-227" />
                <span data-id="element-228">Garantía real de 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}